module.exports = ".pagination{\r\n    text-align: center;\r\n}\r\n.pagination li{  \r\n    cursor: pointer;      \r\n}\r\n.disabled\r\n{\r\n    cursor: not-allowed !important;\r\n    color: #767676d6;\r\n}\r\n.pagination li:hover:not(.disabled) {\r\n    text-decoration: underline;\r\n}\r\n.pagination li.active {\r\n    color: #2a2a2a;\r\n    font-weight: bold;\r\n}"


//////////////////
// WEBPACK FOOTER
// ./src/opc/shared/components/pagination/pagination.component.css
// module id = ./src/opc/shared/components/pagination/pagination.component.css
// module chunks = main